import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { isAppleSignInAvailable } from '@/common/lib/apple-sign-in';
import { Logo } from '@/components/ui/Icons';

import { AppleLoginButton } from '../Buttons/AppleLoginButton';
import { GuestLoginButton } from '../Buttons/GuestLoginButton';

const buttonBase =
  'w-full h-14 flex items-center justify-center rounded-2xl text-white text-lg active:scale-[0.98] transition-transform duration-150 ease-in-out disabled:opacity-70';

/** Login screen of the App Store / Play build (the Mini App keeps its own). */
const NativeLoginScreen: FC = () => {
  const { t } = useTranslation();

  return (
    <main className="w-full h-full flex flex-col bg-[#1A1B20] px-6 pt-[env(safe-area-inset-top)] pb-[calc(env(safe-area-inset-bottom)+2.5rem)]">
      <div className="flex-1 flex items-center justify-center">
        <Logo className="w-[8.5rem]" />
      </div>

      <h1 className="text-white text-[1.75rem] font-extrabold text-center mb-3">
        {t('Welcome, boss')}
      </h1>
      <p className="text-white/55 text-base leading-snug text-center mb-8 mx-auto max-w-[20rem]">
        {t(
          'Jump straight in as a new player, or sign in with Apple to continue your saved game.',
        )}
      </p>

      <div className="flex flex-col gap-3">
        <GuestLoginButton
          label={t('Play as new player')}
          className={`${buttonBase} bg-button-green-gradient shadow-[0_1px_0_0_rgba(255,255,255,0.25)_inset] [text-shadow:0_1px_1px_rgba(0,0,0,0.35)]`}
        />
        {/* Restores a game linked to an Apple ID (Settings → Link Apple ID) */}
        {isAppleSignInAvailable() && (
          <AppleLoginButton
            className={`${buttonBase} gap-2 bg-white !text-black font-semibold`}
          />
        )}
      </div>
    </main>
  );
};

export { NativeLoginScreen };
